import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components';
import {StaticQuery, graphql } from 'gatsby'

import Header from './shared/Header';
import Footer from './shared/Footer';
import favicon from '../img/favicon.png'

const LayoutStyle = styled.div`
  {    
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: rgba(237,237,237,100);
    min-height: 100vh;
    margin: 0 auto;
    overflow: hidden;
  }


  .childrenContainer {
    max-width: 1050px;
    margin: 0 auto;
  }
`

const TemplateWrapper = ({children}) => (
  <LayoutStyle>
   <StaticQuery
     query={graphql`
       query LayoutQuery {
         site {
           siteMetadata {
             title
             description
             siteUrl
           }
         }
       }
     `}
     render={data => (
       <>
         <Helmet>
            <title>{data.site.siteMetadata.title}</title>
            <meta name="title" content={data.site.siteMetadata.title} />
            <meta name="description" content={data.site.siteMetadata.description}/>
            <style type="cssText">{
              `
              body {
                margin: 0;
              }
              `
            }</style>
            <link rel="icon" type="image/svg" href={favicon}/>
        </Helmet> 
        <Header/> 
        <div className="childrenContainer">{children}</div>
        <Footer />
       </>
     )}
   />
  </LayoutStyle>
)

export default TemplateWrapper
